import React, { Component } from "react";
import styled from "styled-components";
import Header from "../Component/Header";
import Contents from "../Component/Contents";
import Buttons from "../Component/Buttons";
import Cont from "../Component/Container";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowLeft,
  faHome,
  faCopy,
  faSave
} from "@fortawesome/free-solid-svg-icons";
import { connect } from "react-redux";
import * as actions from "../Actions";
import { saveAs } from "file-saver";
import { CopyToClipboard } from "react-copy-to-clipboard";
import FinishPic from "../Img/Finish.png";
import NfInit from "../notiflix";
import Notiflix from "notiflix-react";

class Offer extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.save = this.save.bind(this);
    this.notice = this.notice.bind(this);
  }
  save() {
    let blob = new Blob([this.props.text.sum], {
      type: "text/plain;charset=utf-8"
    });
    const date = new Date();
    const seconds = date.getSeconds();
    const minute = date.getMinutes();
    const hour = date.getHours();
    const time = hour + ":" + minute + ":" + seconds;
    saveAs(blob, "OREO_" + time + ".txt");
  }

  notice() {
    const notflix = document.querySelector("#NotiflixNotifyWrap");
    if (this.props.text.sum !== "") {
      if (!notflix) {
        Notiflix.Notify.Success("복사 성공!");
      }
    } else {
      if (!notflix) {
        Notiflix.Notify.Failure("입력된 게 없어요!");
      }
    }
  }

  render() {
    return (
      <div className="fadeIn">
        <Cont className="container">
          <Header
            title={FinishPic}
            desc="글을 전체적으로 다듬어보세요!"
            stage="1"
          ></Header>
          <Contents stage="sum" placeholder="완벽한 글은 없습니다!"></Contents>
          <Buttons
            array={[
              // [
              //   <CopyToClipboard text={this.props.text.sum}>
              //     <FontAwesomeIcon icon={faCopy} />
              //   </CopyToClipboard>,
              //   "/finish",
              //   this.notice
              // ],
              [
                <FontAwesomeIcon className="displayNone" icon={faSave} />,
                "/finish",
                this.save,
                true
              ],
              [<FontAwesomeIcon icon={faHome} />, "/", this.props.clear]
            ]}
          ></Buttons>
        </Cont>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    text: state.Reducer.text
  };
};

const mapDispatchToProps = dispatch => {
  return {
    upload: (title, content) => {
      dispatch(actions.write(title, content));
    },
    clear: () => {
      dispatch(actions.clear());
    }
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Offer);
